
export default {
  setValue({ commit }, payload) {
    commit('setProductValue', payload);
  }
}
